import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import { PlatformTimezoneProvider } from './contexts/PlatformTimezoneContext'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './index.css'
import App from './App.tsx'

const googleClientId = import.meta.env.VITE_GOOGLE_AUTH_ID || ''

createRoot(document.getElementById('root')!).render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <PlatformTimezoneProvider>
            <App />
          </PlatformTimezoneProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
)
